import { render, staticRenderFns } from "./HaircutEducator.vue?vue&type=template&id=023cf00a"
import script from "./HaircutEducator.vue?vue&type=script&lang=js"
export * from "./HaircutEducator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports